export type Article = {
  id: string;
  parentIds: string[] | null;
  title: string;
  body: string;
  publishedDate: any;
};

export enum Labels {
  NEW_FEATURE = 'Neues Feature',
  FEATURE_UPDATE = 'Feature Update',
}
